export default {"src":"/_next/static/media/drag.485f5979.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};